import * as ActionType from '../actions/modal';

const defaultState = {isModalClosed: false};

/**
 * @description
 * Modal rules
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function modal (state = defaultState, action) {
	let newState = {...state};

	switch (action.type) {

		case ActionType.TOGGLE_VISIBILITY : {
			newState.isModalDelayed = action.isModalDelayed;
			return newState;
		}

		case ActionType.CLOSE_MODAL : {
			newState.isModalClosed = true;
			return newState;
		}

		case ActionType.OPEN_MODAL : {
			newState.isModalClosed = false;
			return newState;
		}

		case ActionType.CLOSE_HELP : {
			newState.isHelpOpen = false;
			return newState;
		}

		case ActionType.OPEN_HELP : {
			newState.isHelpOpen = true;
			return newState;
		}

		default:
			return state;
	}
}
